<template>
    <rkm-overlay>
        <rkm-layout-body title="Agendamento">
            <template v-slot:actions>
                <rkm-button
                    @click="exit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    v-if="hasPermissaoAtualizacaoCadastroPaciente"
                    @click="handleBuscarDadosPacienteIntegracaoCns"
                    color="info"
                >
                    Buscar dados do paciente no CADSUS
                </rkm-button>

                <rkm-button
                    @click="$refs.ModalAgendamentoDemandaEspontanea.open()"
                    color="info"
                >
                    Agendamentos e Demandas
                </rkm-button>

                <rkm-button
                    @click="handleCreate"
                    authorize="create-ambulatorio-agendamento"
                    color="primary"
                >
                    Cadastrar agendamento
                </rkm-button>
            </template>

            <rkm-layout-content>
                <Form
                    :id="id"
                    @loaded="loaded"
                    ref="Form"
                />
            </rkm-layout-content>

            <Modal
                :additionals="additionals"
                :paciente-id="id"
                ref="ModalCadastro"
            />

            <ModalIntegracaoCns
                @update="handleIntegracaoCnsUpdate"
                ref="ModalIntegracaoCns"
            />

            <ModalAgendamentoDemandaEspontanea
                :paciente-id="id"
                ref="ModalAgendamentoDemandaEspontanea"
            />
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/ambulatorio/agendamento/Form'
import Modal from '@/components/ambulatorio/agendamento/components/cadastro/Modal'
import ModalAgendamentoDemandaEspontanea from '@/components/ambulatorio/agendamento/components/agendamento-demanda-espontanea/Modal'
import ModalIntegracaoCns from '@/components/integracao/cns/components/busca//Modal'

// Enums.
import classificacao from '@/enums/cadastro/paciente/classificacao'
import subclassificacao from '@/enums/cadastro/paciente/subclassificacao'

// Mixins.
import {formats, permissao, unmask} from '@/mixins'

// Others.
import moment from 'moment'

export default {
    components: {
        Form,
        Modal,
        ModalAgendamentoDemandaEspontanea,
        ModalIntegracaoCns,
    },
    computed: {
        agendamentoClassificacaoBloqueado() {
            return !!this.additionals && this.additionals.agendamentoClassificacaoBloqueado === true
        },
        mensagemClassificacaoBloqueada() {
            const classificacao = this.form ? this.form.paciente.classificacao : null

            return `O cadastro selecionado possui a classificação ${classificacao} e não pode seguir com o
                agendamento de consulta. Atualize o cadastro.`
        },
        podeAtualizarClassificacaoPaciente() {
            return !!this.additionals
                && this.additionals.permiteAtualizarCadastroPaciente === true
                && this.verificarPermissao('update-cadastro-paciente')
        },
        hasPermissaoAtualizacaoCadastroPaciente() {
            let hasPermissao = false

            if (this.additionals && this.additionals.permissoesAtualizacaoCadastroPaciente) {
                if (this.form && this.form.paciente.classificacaoId === this.enums.classificacao.MUNICIPE && this.additionals.permissoesAtualizacaoCadastroPaciente.municipe) {
                    hasPermissao = true
                }
                else if (this.form && this.form.paciente.classificacaoId === this.enums.classificacao.PROVISORIO && this.additionals.permissoesAtualizacaoCadastroPaciente.provisorio) {
                    hasPermissao = true
                }
                else if (this.form && this.form.paciente.classificacaoId === this.enums.classificacao.OUTRO_MUNICIPIO && this.additionals.permissoesAtualizacaoCadastroPaciente.outroMunicipio) {
                    hasPermissao = true
                }
            }

            return hasPermissao
        },
    },
    data: () => ({
        additionals: null,
        enums: {classificacao, subclassificacao},
        form: null,
        others: {moment},
    }),
    methods: {
        loaded(value) {
            this.additionals = value.additionals
            this.form = value.form

            if (this.agendamentoClassificacaoBloqueado) {
                this.handleClassificacaoBloqueada()
            }
        },
        handleClassificacaoBloqueada() {
            const sair = async () => {
                this.exit()
            }

            if (!this.podeAtualizarClassificacaoPaciente) {
                this.showWarningNotification(this.mensagemClassificacaoBloqueada, sair)

                return
            }

            const atualizarClassificacao = async () => {
                this.$router.push({name: 'cadastro-paciente-edit', params: {id: this.id}})
            }

            this.showWarningConfirmation(
                'Atenção',
                this.mensagemClassificacaoBloqueada,
                atualizarClassificacao,
                sair,
                null,
                'Atualizar paciente',
                'Sair'
            )
        },
        handleCreate() {
            if (this.agendamentoClassificacaoBloqueado) {
                this.handleClassificacaoBloqueada()
            }
            else if (this.additionals.cadastroPacienteVencido) {
                this.showWarningNotification(`Paciente com cadastro temporário desatualizado. Agendamento não permitido.`)
            }
            else if (!this.additionals.cnsValido && this.additionals.avisaCnsTemporarioInvalido) {
                this.showWarningNotification('Paciente com CNS inválido. Agendamento não permitido.')
            }
            else if (this.form.paciente.classificacaoId !== this.enums.classificacao.MUNICIPE) {
                if (this.form.especialidadesPermitemNaoMunicipe.length > 0) {
                    let message = ''

                    this.form.especialidadesPermitemNaoMunicipe.forEach(especialidadePermiteNaoMunicipe => {
                        message = message + `<li>${especialidadePermiteNaoMunicipe.nome}</li>`
                    })

                    this.showConfirmation(
                        `
                            Este paciente não está cadastrado como munícipe. É permitido agendamento somente na(s) seguinte(s) especialidade(s):
                            <br/><br/>
                            <ul>${message}</ul>
                            Deseja continuar?
                        `,
                        async () => this.create()
                    )
                } else {
                    this.showWarningNotification(
                        `
                            Este paciente não está cadastrado como munícipe e não há nenhuma especialidade que permite agendamendo
                            para não munícipe. Agendamento não permitido.
                        `
                    )
                }
            } else {

                if (this.form.paciente.subclassificacaoId === this.enums.subclassificacao.TEMPORARIO
                    && this.additionals.avisaCnsTemporarioInvalido) {

                        const confirm = async () => {

                            this.create()
                            return false
                        }

                        const msg = `Paciente com cadastro temporário. Deseja continuar?`

                        this.showConfirmation(msg, confirm)
                        return false
                }

                this.create()
            }
        },
        create() {
            if (this.additionals.avisaCnsProvisorio) {
                this.showWarningNotification('Paciente com CNS provisório.')
            }

            this.$refs.ModalCadastro.create()
        },
        exit() {
            this.$router.push('/ambulatorio/agendamento/index')
        },
        handleBuscarDadosPacienteIntegracaoCns() {
            const params = {
                id: this.form.paciente.cidadaoId,
                nome: this.form.paciente.nome,
                dataNascimento: this.form.paciente.dataNascimento,
                nomeMae: this.form.paciente.nomeMae,
                cns: this.form.paciente.cns ? this.unMaskCns(this.form.paciente.cns) : null,
                cpf: this.form.paciente.cpf ? this.unMaskCpf(this.form.paciente.cpf) : null,
            }

            this.$refs.ModalIntegracaoCns.open(params)
        },
        handleIntegracaoCnsUpdate(item) {
            Object.assign(this.form.paciente, {
                ...item,
                dataNascimento: item.dataNascimento ? this.others.moment(item.dataNascimento).format('DD/MM/YYYY') : null,
                idade: item.idadeFormatada,
            })
        },
    },
    mixins: [formats, permissao, unmask],
    props: {
        id: {type: Number, default: null},
    },
}
</script>